angular.module 'zc.master', [
  'zc.core'
  'zc.users'
  'zc.projects'
  # TODO: remove as master requirement
  'zc.commonApi'
  'zc.masterApi'
]




// WEBPACK FOOTER //
// ./src/master_admin_modules/master/index.js.coffee